import { useTranslation } from "react-i18next";
import { FileText, Image as ImageIcon, Download, Upload, RotateCw } from "lucide-react";
import { DetailCard } from "./DetailCard";
import { fmtDateTime } from "./detailFmt";
import { fileUrlAuth } from "../../../api/fileUrl";

const bytes = (n) => {
  if (!n && n !== 0) return "";
  if (n < 1024) return `${n} B`;
  if (n < 1024 * 1024) return `${(n / 1024).toFixed(1)} KB`;
  return `${(n / (1024 * 1024)).toFixed(2)} MB`;
};

// كارت مرفق فاتورة المورد — فتح/تنزيل + استبدال، أو رفع أوّل مرة.
export const DetailAttachment = ({ doc, onPick, busy }) => {
  const { t } = useTranslation();
  const att = doc.supplier_invoice_attachment;
  const isImg = att?.content_type?.startsWith("image/");
  const Icon = isImg ? ImageIcon : FileText;
  return (
    <DetailCard tid="section-attachment" icon={Icon} tone="emerald"
                title={t("purchases.attach.section.title")}>
      {att ? (
        <div className="grid gap-3">
          <a href={fileUrlAuth(att.url)} target="_blank" rel="noopener noreferrer"
             data-testid="attachment-view"
             className="flex items-center gap-3 rounded-2xl border border-emerald-200 bg-emerald-50 p-3 text-xs transition hover:brightness-95">
            {isImg ? (
              <img src={fileUrlAuth(att.url)} alt="" data-testid="attachment-thumb"
                   className="h-14 w-14 rounded-lg border border-emerald-200 object-cover" />
            ) : (
              <div className="flex h-14 w-14 items-center justify-center rounded-lg border border-emerald-300 bg-white text-emerald-600">
                <FileText className="h-6 w-6" />
              </div>
            )}
            <div className="grid flex-1 gap-0.5 text-start">
              <span className="truncate font-bold" data-testid="attachment-filename">
                {att.filename || "invoice"}
              </span>
              <span className="num font-mono text-[11px] text-muted-foreground">
                {bytes(att.size)} · {fmtDateTime(att.uploaded_at)}
              </span>
              {att.uploaded_by ? (
                <span className="text-[11px] text-muted-foreground">
                  {t("purchases.attach.section.by")}: {att.uploaded_by}
                </span>
              ) : null}
            </div>
            <span className="inline-flex items-center gap-1 rounded-full bg-emerald-600 px-3 py-1 font-bold text-white">
              <Download className="h-3.5 w-3.5" /> {t("purchases.attach.section.open")}
            </span>
          </a>
          {onPick ? (
            <button data-testid="attachment-replace" disabled={busy} onClick={onPick}
                    className="inline-flex items-center justify-center gap-2 rounded-2xl border border-border/60 bg-background px-3 py-2 text-xs font-semibold shadow-neu-sm hover:brightness-110 disabled:opacity-50">
              <RotateCw className="h-3.5 w-3.5" /> {t("purchases.attach.section.replace")}
            </button>
          ) : null}
        </div>
      ) : onPick ? (
        <button data-testid="attachment-upload" disabled={busy} onClick={onPick}
                className="flex w-full items-center justify-center gap-2 rounded-2xl border-2 border-dashed border-border/70 bg-muted/30 py-6 text-xs font-semibold text-muted-foreground transition hover:bg-muted/50 disabled:opacity-50">
          <Upload className="h-4 w-4" /> {t("purchases.attach.section.empty")}
        </button>
      ) : (
        <p className="text-xs text-muted-foreground" data-testid="attachment-none">
          {t("purchases.attach.section.noneReadonly")}
        </p>
      )}
    </DetailCard>
  );
};
